<template>
  <div
    id="contents"
    class="category contents"
  >
    <products-list
      v-if="category.productList.length"
      :productList="category.productList"
      :listTypeBest="listTypeBest"
      :isRewardUse="true"
    ></products-list>
    <contents-none
      v-else
      none-text="상품이 없습니다."
    ></contents-none>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContentsNone from '@/views/base/ContentsNone'
import ProductsList from '@/views/shop/ProductsList'
import ProductAPI from '@/api/product'
import { isLogin } from '@/utils'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  components: {
    ProductsList,
    ContentsNone
  },
  props: {
    categoryId: {
      type: String,
      default: ''
    }
  },
  watch: {
    categoryId: {
      handler(n, o) {
        this.bottom = false
        this.checkCategoryType()
        this.handleAPICall(true)
      }
    },
    bottom: {
      handler(n, o) {
        if (n) {
          this.handleAPICall()
        }
      }
    }
  },
  data() {
    return {
      bottom: false,
      listTypeBest: false
    }
  },
  computed: {
    ...mapGetters('main', ['requestPossible', 'category'])
  },
  methods: {
    ...mapActions('main', ['getProductListByCategory']),
    handleScroll() {
      const { last, page } = this.category
      if (last === false) {
        if (this.bottom === true && this.bottomVisible() === true) {
          this.handleAPICall()
        } else {
           this.bottom = this.bottomVisible()
        }
       
      }
    },
    handleAPICall(reset) {
      this.getProductListByCategory({ categoryId: this.categoryId, reset, callback: ()=> {
          // 실제 화면 크기보다 초기 불러오는 값이 적을때!
        this.$nextTick( this.handleScroll)
      
      }})
    },
    checkCategoryType() {
      const active = document.querySelector(
        '.navigationTop .router-link-exact-active'
      )
      if (active) {
        this.listTypeBest = active.innerHTML.toLowerCase() === 'best'
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      // 제거코드 추가
      window.addEventListener('scroll', this.handleScroll)
      this.checkCategoryType()
      this.handleAPICall(true)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
</style>
